import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Typography } from 'antd'

import { APP_ROUTES } from '../../../common/constants'
import { useDocumentTitle } from '../../../common/hooks'

import { logout } from '../../redux/actions'

const LogoutPage = () => {
  useDocumentTitle(APP_ROUTES.ACCOUNT.children.LOGOUT.label)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(logout())
  }, [dispatch])

  return <Typography.Paragraph>Logging out...</Typography.Paragraph>
}

export default LogoutPage
